export default "__VITE_ASSET__CdaYoR5U__"